let header = document.querySelector('.header-wrapper');
let body = document.querySelector('body')
let html = document.querySelector('html')
let headerBtn = document.querySelector('.header__menu-btn');
let headerMenu = document.querySelector('.menu_drawer');
let menuListBtn = document.querySelector('.mega-menu summary.list-menu__item');
let menuList = document.querySelector('.mega-menu .mega-menu__content');

//header scroll code
let scrollpos = window.scrollY

const scrollChange = 38

const addClassOnScroll = () => header.classList.add("scroll")
const removeClassOnScroll = () => header.classList.remove("scroll");


scrollpos = window.scrollY;

if (scrollpos >= scrollChange) {
    addClassOnScroll()
} else {
    removeClassOnScroll()
}

window.addEventListener('scroll', function () {
    scrollpos = window.scrollY;

    if (scrollpos >= scrollChange) {
        addClassOnScroll()
    } else {
        removeClassOnScroll()
    }

})


//menu burger code

document.querySelector('body').addEventListener('click', (event) => {
    if (event.target === headerBtn) {
        html.classList.toggle('opened')
        headerMenu.classList.toggle('opened')
    }
})

document.querySelector('.header__blur-overlay').addEventListener('click', (event) => {
    html.classList.remove('opened')
    headerMenu.classList.remove('opened')
})


if (headerMenu) {
    headerMenu.addEventListener('click', (event) => {
        if (event.target.closest('a, summary, button')) return;

        const submenu = event.target.closest('.menu-drawer__submenu');
        if (submenu) {
            const openDetails = submenu.closest('details[open]');
            if (!openDetails) return;

            openDetails.removeAttribute('open');
            openDetails.classList.remove('menu-opening');

            const summary = openDetails.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', false);

            const parentMenuElement = openDetails.closest('.submenu-open');
            if (parentMenuElement) parentMenuElement.classList.remove('submenu-open');
            return;
        }

        html.classList.remove('opened');
        headerMenu.classList.remove('opened');

        headerMenu.querySelectorAll('details[open]').forEach((details) => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');

            const summary = details.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', false);
        });
    });
}



document.querySelector('.menu-drawer__close-button').addEventListener('click', function () {
    this.closest('details[open]').removeAttribute('open');
    this.closest('details').querySelector('summary').setAttribute('aria-expanded', false);
})


window.addEventListener('DOMContentLoaded', () => {
  let parent = document.querySelector('.product__description');
  if (!parent) return;

  const bulletsList = parent.querySelector('.product-feature-bullets');
const bulletsHeading = parent.querySelector('.product__description-title');

if (bulletsList) {
  const moreOnParagraph = Array.from(parent.querySelectorAll('p')).find((p) =>
    /^\s*More[\s\u00A0]+on\b/i.test((p.textContent || '').trim())
  );

  if (moreOnParagraph) {
    if (bulletsHeading && bulletsHeading.nextElementSibling === bulletsList) {
      parent.insertBefore(bulletsHeading, moreOnParagraph);
      parent.insertBefore(bulletsList, moreOnParagraph);
    } else {
      parent.insertBefore(bulletsList, moreOnParagraph);
    }
  }
}

  let parentText =
    document.querySelector('.product__description > p.read_more') ||
    document.querySelector('.product__description > p:nth-of-type(1)');
  if (!parentText) return;

  let maxLine = 4;
  let lineHeight = 19;
  let maxTextHeight = maxLine * lineHeight;
  let readMore = document.createElement('span');
  let readLess = document.createElement('span');
  let duplicateSpan = document.createElement('span');
  let truncatedSpan = document.createElement('span');

  truncatedSpan.classList.add('truncated');
  truncatedSpan.innerHTML = parentText.innerText;
  duplicateSpan.innerHTML = parentText.innerText;
  duplicateSpan.style.display = 'none';
  parentText.innerText = '';

  readMore.setAttribute('role', 'button');
  readMore.setAttribute('class', 'read-more');
  readMore.innerText = 'Read More';

  readLess.setAttribute('role', 'button');
  readLess.setAttribute('class', 'read-less');
  readLess.innerText = 'Read Less';
  readLess.style.display = 'none';
  readLess.style.marginLeft = '0.5rem';

  parentText.appendChild(truncatedSpan);
  parentText.appendChild(duplicateSpan);
  parentText.appendChild(readMore);
  parentText.appendChild(readLess);

  truncatedSpan.style.maxHeight = maxTextHeight + 'px';
  truncatedSpan.style.lineHeight = lineHeight + 'px';

  if (truncatedSpan.innerText.length > 146) {
    truncatedSpan.style.overflow = 'hidden';
    truncatedSpan.innerHTML = truncatedSpan.innerText.substring(0, 146 - 4 - 8) + '... ';
  }

  readMore.addEventListener('click', () => {
  duplicateSpan.style.display = 'inline';
    truncatedSpan.style.display = 'none';
    readMore.style.display = 'none';
    readLess.style.display = 'inline';
  });

  readLess.addEventListener('click', () => {
    duplicateSpan.style.display = 'none';
    truncatedSpan.style.display = 'inline';
    readMore.style.display = 'inline';
    readLess.style.display = 'none';
  });
});

document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

  setTimeout(function () {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }, 250);
});